import { memo, useContext } from 'react';
import AllDayEventDayTimeGrid from './Event';
import AllDaySlotDayTimeGrid from './Slot';
import { CalendarContext } from '../reducer/CalendarContext';
import { CalendarMode, MergeableEventListItem, Schedule } from '../reducer';
import { DateTime } from 'infras/datetime';

export interface Props {
  startedAt: DateTime;
  onClickEvent?: (event: MergeableEventListItem, el: HTMLElement) => void;
  onUpdateSchedule?: (schedule: Schedule) => void;
  selectedEventId?: string;
}
const Component = memo((props: Props) => {
  const { state, dispatch } = useContext(CalendarContext);
  if (state.calendarMode === CalendarMode.Event) {
    return <AllDayEventDayTimeGrid {...props} />;
  }
  if (state.calendarMode === CalendarMode.Slot) {
    return <AllDaySlotDayTimeGrid {...props} />;
  }
  return null;
});
export default Component;
